import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, FormControl, FormLabel, Input, FormErrorMessage, Stack } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import EmailValidator from "email-validator";
import { getAPIEndpoint } from "views/config";
import axios from "axios";
import { logger } from "views/models/logging";
import { ToastContainer, toast } from 'react-toastify';

export function AddClient({ isOpen = false, onClose = null, refreshData, creator, authKey }) {
    const initialRef = useRef(null);
    const [clientId, setClientId] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [contactPhoneNo, setContactPhoneNo] = useState('');
    const [emailIsError, setEmailIsError] = useState(false);
    const [isLoading, setIsloading] = useState(false);

    useEffect(() => {
        if (email.length > 0 && !EmailValidator.validate(email)) {
            setEmailIsError(true);
        }
        else {
            setEmailIsError(false);
        }
    }, [email]);

    const addClient = async () => {
        setIsloading(true);

        const params = {
            agentId: clientId,
            agentName: companyName.trim(),
            agentEmail: email.trim(),
            agentPhone: contactPhoneNo.trim(),
            creator
        };

        const apiHeader = {
            headers: {
                "authorization": `Bearer ${authKey}`
            }
        }

        try {
            const response = await axios.post(getAPIEndpoint('agent'), params, apiHeader);
            if (response) {
                const { status, data } = response.data;
                if (status === 'success' && data) {
                    setIsloading(false);
                    refreshData(authKey);
                    clear();
                    onClose();
                }
                else {
                    if (data[0].error.includes('duplicate'))
                        toast.error("A client with the specified identifier already exists.");
                    else
                        toast.error("Sorry, we are unable to add client at this time. Please try again later.");
                }
            }
        } catch (error) {
            toast.error("Sorry, we are unable to add client at this time. Please try again later.");
            await logger({ task: "Add Client", error: error.toString() });
        }

        setIsloading(false);
    }

    const closeModal = () => {
        clear();
        onClose();
    }

    const clear = () => {
        setClientId('');
        setCompanyName('');
        setContactPhoneNo('');
        setEmail('');
    }

    const processForm = async (e) => {
        e.preventDefault();
        await addClient();
    }

    return (
        <>
            <Modal isCentered initialFocusRef={initialRef} closeOnOverlayClick={false} isOpen={isOpen} onClose={closeModal}>
                <ModalOverlay />
                <ModalContent>
                    <form onSubmit={processForm}>
                        <ModalHeader>Create your account</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={2}>
                            <div style={{ overflow: 'auto', maxHeight: '60vh' }}>
                                <FormControl isRequired mt={2}>
                                    <FormLabel>Client Identifier</FormLabel>
                                    <Input type="text" ref={initialRef} value={clientId} onChange={e => setClientId(e.target.value)} />
                                </FormControl>

                                <FormControl isRequired mt={4}>
                                    <FormLabel>Company name</FormLabel>
                                    <Input type="text" value={companyName} onChange={e => setCompanyName(e.target.value)} />
                                </FormControl>

                                <FormControl isInvalid={emailIsError} isRequired mt={6}>
                                    <FormLabel>Email address</FormLabel>
                                    <Input type='email' value={email} onChange={e => setEmail(e.target.value)} />
                                    {emailIsError && <FormErrorMessage>Please enter a valid email address.</FormErrorMessage>}
                                </FormControl>

                                <FormControl isRequired mt={6}>
                                    <FormLabel>Contact phone number</FormLabel>
                                    <Input type="text" value={contactPhoneNo} onChange={e => setContactPhoneNo(e.target.value)} />
                                </FormControl>
                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <Stack direction={'row'}>
                                <Button onClick={closeModal}>Cancel</Button>
                                <Button disabled={emailIsError} isLoading={isLoading} type="submit" bgColor='#0C7FE9' color='white' _hover={{
                                    bg: "#3c98ed"
                                }} mr={3}>
                                    Add Client
                                </Button>
                            </Stack>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>
            <ToastContainer />
        </>
    )
}